import * as moment from 'moment';

export const environment = {
    production: false,
    development: true,
    local: false,
    API_SERVER_URL: 'https://api-demo-proticket.mypeopleapps.com',
    API_ORDERS_STORE_URL: 'https://api-dev.proticket.store',
    NOW: moment(new Date()).format('YYYY-MM-DD HH:MM:ss'),
    DEFAULT_STATUS_ACTIVE: 160445,
    DEFAULT_EMPTY_TYPOLOGY:  160000,
    DEFAULT_COUNTRY_GUATEMALA: 160531,
    DEFAULT_EVENT_CATEGORY_TYPOLOGY: 160716,
    TICKET_TYPE_CATEGORY: 160712,
    DEFAULT_TICKET_PAGO: 160713,
    DEFAULT_ORDER_STATUS_DRAFT: 160754,
    MIN_CHARACTERES_ALLOWED: 2,
    DEFAULT_PROTECTED_FAN_SHOP_SETTING_TYPOLOGY: 160933
}
